module.exports = __webpack_public_path__ + "static/media/grin-tongue.fabe2060.svg";